import React from "react";
import { Route, Navigate, Outlet } from "react-router-dom";
import RouteConstants from "../common/RouteConstants";
import jwt_decode from "jwt-decode";
import { Role } from "../helper";

export const PrivateRoute = ({ children, roles, ...rest }) => {
  let currentUserLocalStorage = sessionStorage.getItem("accessToken");
  if (!currentUserLocalStorage) {
    //console.log("Redirecting to login...");
    // not logged in so redirect to login page with the return url
    return <Navigate to={{ pathname: "/login", state: {} }} />;
  } else {
    let jwt = sessionStorage.getItem("accessToken");
    const currentUser = jwt_decode(jwt);
    if (currentUser) {
      if (currentUser.exp < Date.now() / 1000) {
        sessionStorage.clear();
        return <Navigate to={{ pathname: RouteConstants.LOGIN }} />;
      }
    }

    const currUser = JSON.parse(sessionStorage.getItem("currentUser"));

    let playerProfileFlag = (rest && rest.playerProfileFlag) || true;

    let combineResultsFlag = (rest && rest.combineResultsFlag) || true;

    if (
      currUser &&
      currUser.appRoles &&
      (currUser.appRoles.includes(Role.Team) ||
        currUser.appRoles.includes(Role.CombineBallotUser)) &&
      playerProfileFlag === false
    ) {
      return <Navigate to={{ pathname: RouteConstants.UNAUTHORIZED }} />;
    }

    /// check if route is restricted by role
    //if (roles && roles.indexOf(currentUser.role) === -1) {
    if (
      roles &&
      currUser &&
      currUser.appRoles &&
      !roles.some((r) => currUser.appRoles.includes(r))
    ) {
      // role not authorised so redirect to home page
      //return <Navigate to={{ pathname: "/login" }} />;
      return <Navigate to={{ pathname: RouteConstants.UNAUTHORIZED }} />;
    }

    if (
      currUser &&
      currUser.appRoles &&
      (currUser.appRoles.includes(Role.Team) ||
        currUser.appRoles.includes(Role.CombineBallotUser)) &&
      combineResultsFlag === false
    ) {
      return <Navigate to={{ pathname: RouteConstants.UNAUTHORIZED }} />;
    }

    // authorised so return component
    return <Outlet />;
  }
};
